{
  "maxLength": 30,
  "minLength": 3,
  "pattern": "^[a-z][a-z0-9-]*$",
  "type": "string",
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "title": "Org name (generated from core/platform/org.py -- do not edit)",
  "description": "An org's name is a DNS label: it is the subdomain, the bucket segment and the anchor project's prefix. Reserved platform names are refused by the server and deliberately absent here -- that list is policy, not shape."
}
